import React from 'react';

import styled from 'styled-components';

import RecommendationCompanyStructured from './RecommendationCompanyStructured';
import RecommendationMarkdown from './RecommendationMarkdown';
import { parseStructureFromJSON } from '../../utils/helpers/object';

const Container = styled.div`
  display: flex;
  gap: 15px;
  font-family: var(--font-regular);
`;

type Props = {
  description: string;
};

const RecommendationCompanyReasoning = ({ description }: Props) => {
  const structuredSolution = parseStructureFromJSON(description);
  return (
    <Container>
      {structuredSolution && <RecommendationCompanyStructured structure={structuredSolution} />}
      {!structuredSolution && <RecommendationMarkdown>{description}</RecommendationMarkdown>}
    </Container>
  );
};

export default RecommendationCompanyReasoning;
